export const apiUrl = window.insify_runtime_config.API_ENDPOINT;
